import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { ApiCommonService } from 'src/app-core/services/api-common.service';
import { CommonService } from 'src/app-core/services/common.service';

@Injectable({
    providedIn: 'root'
})
export class JobsService {

    orderHeaderDetails: any;
    updateOrderHeaderDetails = new Subject<number>();

    constructor(
        private apiCommonService: ApiCommonService) {
    }

    getOrderHeaderDetails(): Observable<any> {
        return this.updateOrderHeaderDetails.asObservable();
    }

    job(data: object): Observable<any> {
        return this.apiCommonService.post('Jobs', data);
    }

    updateJob(data: object): Observable<any> {
        return this.apiCommonService.post('Jobs/Update', data);
    }

    getOrderGridRecords(event: any, searchQuery: string, statusQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Jobs', event, searchQuery, statusQuery, '');
    }

    getOrderInshopGridRecords(event: any, searchQuery: string, statusQuery: string): Observable<any> {
        return this.apiCommonService.getGridRecords('Orders/InShop', event, searchQuery, statusQuery, '');
    }

    exportJobs(event: any, searchQuery: string, queryString): Observable<object> {
        return this.apiCommonService.export('Jobs/export', event, searchQuery, queryString, '');
    }

    getJob(id: string): Observable<any> {
        return this.apiCommonService.get(`Jobs/Id?Id=${id}`);
    }

    getDimWeightFactors(): Observable<any> {
        return this.apiCommonService.get(`Quotes/DimWeightFactor/Lookup`);
    }

    getJobTypes(): Observable<any> {
        return this.apiCommonService.get(`Quotes/JobTypeLookup?IsJobRelated=true`);
    }

    getJobLookup(queryString: any): Observable<any> {
        return this.apiCommonService.get(`Jobs/LookUp?${queryString}`);
    }

    gerJobsCountForLeftMenu(queryString: string): Observable<any> {
        return this.apiCommonService.get(`Common/JobsCount?${queryString}`);
    }

    finalizeJob(data: any): Observable<any> {
        return this.apiCommonService.post('Jobs/Finalize', data);
    }

    isMonthClosed(date: string): Observable<any> {
        return this.apiCommonService.get(`Reports/IsMonthClosed?ReportMonth=${date}`);
    }

    queueJobSync(orderId: string): Observable<any> {
        return this.apiCommonService.post(`Integrations/QueueJobSync`, {
            orderId: orderId
        });
    }

}
